import base64 from "base-64";

export default function stripSvgDataPrefix(source) {
  // Safari will not decode the base64 url data when used with `fetch`. If
  // we have base64 data, then decode and return it.
  const DATA_PREFIX = "data:image/svg+xml;base64,";
  if (source.indexOf(DATA_PREFIX) === 0) {
    return base64.decode(source.substr(DATA_PREFIX.length));
  }

  return source;
}
